import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen bg-[#F8F5F0] w-full flex justify-center" data-id="element-0">
      {/* Mobile-first container that acts like a premium app view on desktop */}
      <main className="w-full max-w-lg bg-cream min-h-screen shadow-2xl relative overflow-x-hidden" data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <WhatsInsideSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <SocialProofSection data-id="element-6" />
        <UrgencySection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FooterSection data-id="element-9" />
      </main>
      <SocialProofToast data-id="element-10" />
    </div>;
}